import { profile } from 'console';

type SchemaDefinition = Record<string, string>;
export const SCHEMAS: Record<string, SchemaDefinition> = {
  v1: {
    token: 'id',
    user: 'recordId',
  },
};

SCHEMAS.v2 = {
  ...SCHEMAS.v1,
  userRoles: 'id, name',
};
SCHEMAS.v3 = {
  ...SCHEMAS.v2,
  teacherProfiles: 'uuid, uuid, id, user, username, syncStatus',
  principalProfiles: 'uuid, uuid, user, username, syncStatus',
  users: 'uuid, uuid, username, syncStatus',
};

SCHEMAS.v4 = {
  // User-related tables
  token: 'id',
  user: 'recordId',
  userRoles: 'id, name',
  users: 'uuid, uuid, username, syncStatus',
  // Profile tables
  teacherProfiles: '++id,uuid,user,syncStatus',
  principalProfiles: '++id,uuid,user,syncStatus',
  coachProfiles: '++id,uuid,user,syncStatus',
  areaEducationOfficerProfiles: '++id,uuid,user,syncStatus',
  regionalManagerProfiles: '++id,uuid,user,syncStatus',
  programManagerProfiles: '++id,uuid,user,syncStatus',
  administratorProfiles: '++id,uuid,user,syncStatus',
  studentProfiles: '++id,uuid,user,syncStatus',
  // School-related tables
  schools: '++id,name,address,city,emis,group,region,schoolGroup',
  schoolGroups: '++id,name,parent,schoolIds',
  schoolRegions: '++id,name',
};

SCHEMAS.v5 = {
  ...SCHEMAS.v4,
  teacherProfilesV2: 'uuid, user, userUsername, syncStatus',
  principalProfilesV2: 'uuid, user, userUsername, syncStatus',
  coachProfilesV2: 'uuid, user,  userUsername, syncStatus',
  areaEducationOfficerProfilesV2: 'uuid, user,  userUsername, syncStatus',
  regionalManagerProfilesV2: 'uuid, user,  userUsername, syncStatus',
  programManagerProfilesV2: 'uuid, user,  userUsername, syncStatus',
  administratorProfilesV2: 'uuid, user,  userUsername, syncStatus',
  studentProfilesV2: 'uuid, user,  userUsername, syncStatus',

  allCoachProfilesV2: 'id,name,syncStatus',
};
SCHEMAS.V6 = {
  ...SCHEMAS.v5,
  usersV1: 'username, uuid, syncStatus',
  features: 'id',
  profileLabels: 'id',
};

SCHEMAS.v7 = {
  ...SCHEMAS.V6,
  transferUserProfiles: 'uuid,syncStatus',
};

SCHEMAS.v8 = {
  ...SCHEMAS.v7,
  schoolsV1: 'uuid,id,name,address,city,emis,group,region,schoolGroup,syncStatus',
};
